<h4>{{ title != null ? title : 'standard-selection.title' | translate }}</h4>
<h5>{{ subtitle != null ? subtitle : 'standard-selection.subtitle' | translate }}</h5>

<div class="standard-selection-buttons-wrapper">
	<div class="standard-selection-buttons">
		@for (standard of (possibleStandards() | async); track standard) {
			<standard-button [nbTooltipClass]="'tooltip'" [nbTooltip]="'standard-selection.iso-27701-tooltip' | translate" [nbTooltipDisabled]="disableTooltip(standard)"
							 [disabled]="standardSelectionDisabled || (dependentStandardNotChosen(standard) | async)" [standardName]="standard" [isSelected]="isStandardSelected(standard)"
							 (onStandardSelected)="selectStandard(standard, $event)"></standard-button>
			<div class="break"></div>
		}
	</div>

	@if (showValidationMessage) {
		<div class="validation-message">{{ 'standard-selection.validation-message' | translate }}</div>
	}
</div>
